import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  class: "container is-max-desktop",
  id: "bottom"
}
const _hoisted_3 = { class: "columns is-gapless" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "column" }
const _hoisted_11 = {
  href: "https://github.com/gqgs/3x3-generator",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.processing)
      ? (_openBlock(), _createElementBlock("progress", {
          key: 0,
          class: "progress is-small is-primary my-4",
          value: _ctx.progress,
          max: "100"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DropDown, {
          class: "column",
          options: ['200', '400'],
          onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cellSize = $event))
        }, {
          selected: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.size*_ctx.cellSize) + "x" + _toDisplayString(_ctx.size*_ctx.cellSize), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.size*parseInt(slotProps.option)) + "x" + _toDisplayString(_ctx.size*parseInt(slotProps.option)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_DropDown, {
          class: "column",
          options: ['no-denoise', 'conservative', 'denoise1x', 'denoise2x', 'denoise3x', 'pro-no-denoise', 'pro-conservative', 'pro-denoise3x'],
          onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.denoise = $event)),
          disabled: _ctx.cellSize == 200
        }, {
          selected: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.denoise), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.option), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_DropDown, {
          class: "column",
          options: _ctx.workerList,
          onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.workers = $event)),
          title: "Max number of workers used when upscaling images",
          disabled: _ctx.cellSize == 200
        }, {
          selected: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.workers), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(" Upscale workers: " + _toDisplayString(slotProps.option), 1)
          ]),
          _: 1
        }, 8, ["options", "disabled"]),
        _createVNode(_component_DropDown, {
          class: "column",
          options: ['image/jpeg', 'image/png', 'image/webp'],
          onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.download($event)))
        }, {
          selected: _withCtx(() => [
            (_ctx.processing)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.progress_msg), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Download"))
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(" Download (" + _toDisplayString(slotProps.option) + ") ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_DropDown, {
          class: "column",
          options: ['2', '3', '4', '5'],
          onClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSize($event)))
        }, {
          selected: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.size) + "x" + _toDisplayString(_ctx.size), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.option) + "x" + _toDisplayString(slotProps.option), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button is-small",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.select_color = !_ctx.select_color))
          }, "Border"),
          (_ctx.select_color)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("input", {
                  class: "button is-small",
                  type: "color",
                  id: "color",
                  value: _ctx.color,
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateColor($event)))
                }, null, 40, _hoisted_8),
                _createElementVNode("input", {
                  class: "is-small",
                  type: "range",
                  value: _ctx.alpha,
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateAlpha($event)))
                }, null, 40, _hoisted_9)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createVNode(_component_ion_icon, {
              class: "pt-3",
              id: "github",
              name: "logo-octocat"
            })
          ])
        ])
      ])
    ])
  ], 64))
}